import {
  EmailOutlined,
  LayersOutlined,
  LockOutlined,
} from "@mui/icons-material";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CustomLink } from "./CustomLink";
import Icon from "../HOC/Icon";
import useAccount from "../../hooks/useAccount";

export const orderLinks = [
  { to: "/settings/order/", title: "", icon: EmailOutlined, label: "Mark Up" },
  {
    to: "/settings/order/commission",
    title: "commission",
    icon: LockOutlined,
    label: "Commision",
  },
  // {to: "/settings/order/points", title: 'points', icon: LayersOutlined, label: "Miles Points"},
  // {to: "/settings/order/suppliers", title: 'suppliers', icon: 'carbon:scis-transparent-supply', label: "Suppliers"},
  {
    to: "/settings/order/dealcodes",
    title: "dealcodes",
    icon: "iconamoon:discount-light",
    label: "Deal Codes",
  },
  {
    to: "/settings/order/emailTemplates",
    title: "emailTemplates",
    icon: "fluent:mail-template-20-regular",
    label: "Email Templates",
  },
  {
    to: "/settings/order/airlineCommission",
    title: "airlineCommission",
    icon: () => <Icon icon="qlementine-icons:money-16" className="!w-4 !h-4" />,
    label: "Airline Commision",
  },
  {
    to: "/settings/order/tax",
    title: "tax",
    icon: () => <Icon icon="mdi:percent" className="!w-4 !h-4" />,
    label: "Tax",
  },
  {
    to: "/settings/order/splitCommission",
    title: "splitCommission",
    icon: () => <Icon icon="ix:coins" className="!w-4 !h-4" />,
    label: "Split Commission",
  },
  {
    to: "/settings/order/visa",
    title: "visa",
    icon: () => <Icon icon="mdi:passport" className="!w-4 !h-4" />,
    label: "Visa",
  },
];

export default function OrderNav() {
  const location = useLocation();
  const { checkPermission } = useAccount();

  let pathname = location.pathname.split("/");
  let page = pathname[pathname.length - 1];

  function checkAccess(obj) {
    switch (obj?.title) {
      case "dealcodes":
        return checkPermission(["read:deal-code"]);
      case "emailTemplates":
        return checkPermission(["read:email-template"]);
      case "airlineCommission":
        return checkPermission(["read:airline-commission"]);
      case "splitCommission":
        return checkPermission(["read:intraverse-commission"]);
      default:
        return true;
    }
  }

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="hidden sm:flex gap-2 overflow-x-auto overflow-hidden w-full">
        {orderLinks
          ?.filter((obj) => checkAccess(obj))
          .map(({ to, title, icon, label }, i) => (
            <CustomLink
              key={i}
              to={to}
              active={!page ? title === "" : title === page}
              Icon={icon}
              label={label}
            />
          ))}
      </div>
      <div className="sm:hidden vector-bg text-white p-2">
        <h3 className="capitalize text-white">{page || "Mark Up"}</h3>
      </div>

      <hr className="hidden sm:block mb-2" />
      <Outlet />
    </div>
  );
}
